export default "__VITE_ASSET__D8zm2D7l__"